import React from "react";
import Image from "../image";

const CardWithSVGIcon = ({icon, title, key}) => {
    return (
        <div className="flex items-center py-2" key={key}>

            <div className="icon w-14">
                <Image image={icon?.localFile} sourceUrl={icon?.sourceUrl} imageAlt={title} imageClass={'h-10 w-10'} icon={true} />
            </div>

            <div className="title">
                {title}
            </div>

        </div>
    );
}

export default CardWithSVGIcon;